import type { GetCalendarsForCalendarProviderAccountResponse } from '../types/GetCalendarsForCalendarProviderAccountResponse';
import type { GetCalendarsForCalendarProviderAccountErrorResponse } from '../types/GetCalendarsForCalendarProviderAccountErrorResponse';
import { makeGetRequest } from 'owa-ows-gateway';
import type { TraceErrorObject } from 'owa-trace';
import { isSuccessStatusCode, HttpStatusCode } from 'owa-http-status-codes';
import { PerformanceDatapoint } from 'owa-analytics';

export type GetCalendarsForCalendarProviderAccountReturnType =
    | { isError: false; response: GetCalendarsForCalendarProviderAccountResponse }
    | { isError: true; response: GetCalendarsForCalendarProviderAccountErrorResponse };

export async function getCalendarsForCalendarProviderAccount(
    calendarProviderAccountId: string
): Promise<GetCalendarsForCalendarProviderAccountReturnType> {
    const datapoint = new PerformanceDatapoint('teamSnapGetCalendars');
    const url = `ows/api/beta/calendarProviderAccounts/${calendarProviderAccountId}/calendars`;
    const response: Response = await makeGetRequest(
        url,
        undefined /*correlationId*/,
        true /*returnFullResponse*/
    );

    if (isSuccessStatusCode(response.status)) {
        const responseText = await response.text();
        const getCalendarsResponse = JSON.parse(responseText);

        endGetCalendarsDatapoint(
            datapoint,
            response.status,
            getCalendarsResponse?.calendars ? getCalendarsResponse.calendars.length : 0,
            null
        );

        return { isError: false, response: getCalendarsResponse };
    } else if (response.status === HttpStatusCode.BadGateway) {
        const responseText = await response.text();
        const getCalendarsResponse = JSON.parse(responseText);

        endGetCalendarsDatapoint(datapoint, response.status, 0, 'BadGateway');

        return { isError: true, response: getCalendarsResponse };
    } else {
        var error: TraceErrorObject = new Error(
            `GET request to ${url} failed, http error:${response.status}`
        );

        endGetCalendarsDatapoint(datapoint, response.status, 0, error.message);

        throw error;
    }
}

function endGetCalendarsDatapoint(
    datapoint: PerformanceDatapoint,
    responseStatus: number,
    numCalendars: number,
    error: string
) {
    datapoint.addCustomData({
        responseStatus: responseStatus,
        numCalendars: numCalendars,
        error: error,
    });

    datapoint.end();
}
